export function formatVehiclePublicLabel(v: {
  fleet_number: string;
  registration_plate?: string | null;
}): string {
  const plate = v.registration_plate?.trim();
  return plate || v.fleet_number;
}

export function formatVehicleAdminLabel(
  v: {
    fleet_number: string;
    registration_plate?: string | null;
  },
  /** Localized label when plate is missing (default English for AU product UI) */
  missingPlateLabel = 'Plate pending'
): string {
  const plate = v.registration_plate?.trim();
  return plate ? `${v.fleet_number} · ${plate}` : `${v.fleet_number} · ${missingPlateLabel}`;
}
